import * as Services from './Services';
import * as Coupons from './Coupons';
import * as Discounts from './Discounts';
import * as Orders from './Orders';
import * as Receipt from './Receipt';
import * as Car from './Car';
import * as Vip from './Vip';
import * as Statistics from './Stats';

export { Services, Coupons, Discounts, Orders, Receipt, Car, Vip, Statistics };



// WEBPACK FOOTER //
// ./src/services/smartparking-api/index.js